export default "__VITE_ASSET__zY47NVCa__"